package com.ervasstudio.tracoemovimento.util

import com.ervasstudio.tracoemovimento.model.GoogleUser
import dev.gitlive.firebase.auth.externals.GoogleAuthProvider
import dev.gitlive.firebase.auth.externals.getAuth
import dev.gitlive.firebase.auth.externals.signInWithPopup
import kotlinx.coroutines.await




suspend fun signInWithGoogle(): GoogleSignInResult = try {
    val auth = getAuth()
    val provider = GoogleAuthProvider()
    val credential = signInWithPopup(auth, provider).await()
    val user = credential.user

    GoogleSignInResult.Success(
        GoogleUser(
            uid = user.uid,
            displayName = user.displayName,
            email = user.email,
            photoUrl = user.photoURL,
        )
    )
} catch (e: Throwable) {
    val code = e.asDynamic().code as? String
    GoogleSignInResult.Error(code, e.message ?: "Erro desconhecido")
}